import { call, select, put } from 'redux-saga/effects';

import { callAPI, METHODS } from '../../api';
import {
  deleteIntegration,
  removeApplication,
} from '../../../effects/organization';
import { setBannerAPIRequestState } from '../../../effects/message';

export default function* removeIntegration(action) {
  const { AUTH_SERVER_URL } = yield select((state) => state.application.env);
  const url = `${AUTH_SERVER_URL}/integrations?integrationId=${action.payload.id}&integrationUserId=${action.payload.integrationUserId}&mediaIntegrationType=${action.payload.mediaIntegrationType}&appId=${action.payload.applicationId}`;

  const { success, error } = yield call(callAPI, {
    url,
    method: METHODS.DELETE,
  });

  if (!error && success) {
    yield put(
      removeApplication({
        appId: action.payload.applicationId,
      }),
    );
    yield put(
      deleteIntegration({
        id: action.payload.id,
      }),
    );
    yield put(
      setBannerAPIRequestState({
        bannerState: 'success',
        bannerMessage: 'Integration has been successfully removed!',
      }),
    );
  } else {
    console.error(error)
    yield put(
      setBannerAPIRequestState({
        bannerState: 'error',
        bannerMessage:
          'Something went wrong while removing your integration...',
      }),
    );
  }
}
